import React, { Component } from 'react';
import schedule_icon from '../../Images/Daikin_Images/image/Schedule.png';
import interlock_icon from '../../Images/Daikin_Images/image/Interlock.png';
import scene_icon from '../../Images/Daikin_Images/image/Scene.png';
import changeover_icon from '../../Images/Daikin_Images/image/AutoChangeover.png';
import user_administration_icon from '../../Images/Daikin_Images/image/Account.png';
import layout_editor_icon from '../../Images/Daikin_Images/image/Pattern.png';
import point_settings_icon from '../../Images/Daikin_Images/image/PointSetup.png';
import history_icon from '../../Images/Daikin_Images/image/History.png';
import lang_icon from '../../Images/Daikin_Images/image/Lang.png';
import passwd_icon from '../../Images/Daikin_Images/image/Password.png';
import qr_icon from '../../Images/Daikin_Images/image/QR.png';
import uniview_icon from '../../Images/uniview.jpg';
import logout_icon from '../../Images/Daikin_Images/image/Logout.png';
import check_update_icon from '../../Images/Daikin_Images/icon/Alert.png';
import ipcam_icon from '../../Images/Daikin_Images/image/Ipcam.png';
import guest_room_settings_icon from '../../Images/Daikin_Images/image/GRedit.png';
import msm_settings_icon from '../../Images/Daikin_Images/image/MSMsetup.png';
import t_c_icon from '../../Images/Daikin_Images/image/TermsAndCondition.png';
import version_icon from '../../Images/Daikin_Images/image/Version.png';
import { getMonthName, getLocale, df_options } from '../Common/Common';
import ConfirmMessage from '../Part_Sample/ConfirmMessage';
import google_home_icon from '../../Images/Daikin_Images/image/google_home.png';
import iaq_settings_icon from '../../Images/Daikin_Images/image/IAQsettings.png';

// Tommy - 10/09/2021
//import alexa_icon from '../../Images/Daikin_Images/image/alexa.png';

export default class System extends Component {
	constructor(props) {
		super(props);

		this.lastClickTime = false;

		this.state = {
			is_show_confirm: false
		}
	}

	preventMultipleTaps = () => {
		if(this.lastClickTime == false) {		//Check if it is first click, allow
			this.lastClickTime = true;
			return true;
		} else {
			return false;
		}
	}

	handleSceneSetting = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.showLoading();
		this.props.receiver.stored_params.from = "System";
		this.props.receiver.next_component = 'Scene_Settings';
		this.props.receiver.getScene();
	}

	handleSchedule = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.showLoading();
		this.props.receiver.next_component = 'Schedule';
		this.props.receiver.getScene();
	}

	handleInterlock = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.showLoading();
		this.props.receiver.next_component = 'Interlock';
		this.props.receiver.getScene();
	}

	handleChangeOver = () => {
		if (!this.preventMultipleTaps()) return;

		this.props.receiver.getChangeOverGroups();
	}

	handleIAQSetting = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.showLoading();
		this.props.receiver.stored_params.from = "System";
		this.props.receiver.next_component = 'IAQ_Monitoring_Settings';
		this.props.receiver.readJSONFile({ name: 'iaq_monitoring_settings.json' });
	}

	handleUserAdministration = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.showLoading();
		this.props.receiver.next_component = 'User_Administration';
		this.props.receiver.getAccounts();
	}

	handleLayoutEditor = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.showLoading();
		this.props.receiver.next_component = 'Layout_Editor';
		this.props.receiver.getGroups();
	}

	handlePointSettings = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.showLoading();
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('Point_Settings');
	}

	handleGuestRoomSettings = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.showLoading();
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.receiver.next_component = 'Guest_Room_Settings';
		this.props.receiver.getGuestRooms();
	}

	handleHistory = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.showLoading();
		this.search_date = new Date(); // Also the search_start_date

		let search_details = {
			year: this.search_date.getFullYear(),
			month: this.search_date.getMonth() + 1,
			day: this.search_date.getDate()
		}

		this.props.receiver.getHistory(search_details);
	}

	rcvHistory = (history_data) => {
		window.app.hideLoading();
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('History', { history_data: history_data, from: 'System', search_date: this.search_date });
	}

	handleLanguage = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('Language');
	}

	handlePassword = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('Password');
	}

	handleStartDate = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('Start_Date');
	}

	handleQRGenerator = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('QR_Generator');
	}

	handleIPCamSettings = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('IPCam_Settings');
	}

	handleCheckUpdate = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.showLoading();
		this.props.receiver.checkUpdates();
	}

	handleMSMSettings = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('MSM_Settings');
	}

	rcvCheckUpdate = (data) => {
		this.lastClickTime = false;

		window.app.hideLoading();
		if (data.result == 'OK') {
			if (this.props.receiver.active_controller.user_class == 'Admin') {
				this.setState({ is_show_confirm: true });
			} else {
				window.app.showToast(this.props.receiver.getString('update_available'), 3000);
			}
		} else {
			window.app.showToast(this.props.receiver.getString('no_new_update'), 3000);
		}
	}

	// After update show status
	onConfirmUpdate = (is_pressed_ok) => {
		if (is_pressed_ok) {
			window.app.showLoading();
			this.props.receiver.updateController();
		}

		this.setState({ is_show_confirm: false });
	}

	rcvUpdateCommandSent = (data) => {
		this.lastClickTime = false;

		window.app.hideLoading();
		if (data.result == 'OK') {
			window.app.showToast(this.props.receiver.getString('update_comp'), 3000);
		} else {
			window.app.showToast(this.props.receiver.getString('update_fail'), 3000);
		}
	}

	rcvReadJSONFile(response) {
		this.lastClickTime = false;

		window.app.hideLoading();
		if (response.result != 'NG') {
			window.app.content_area.current.switch_content.current.handleShowBottomControls();
			this.props.content_handler('IAQ_Monitoring_Settings', { response: response.data });
		} else {
			this.lastClickTime = false;
			window.app.hideLoading();
			window.app.showToast(this.props.receiver.getString('json_read_failed'), 3000);
		}
	}

	handleLogout = () => {
		if (!this.preventMultipleTaps()) return;

		this.props.receiver.logout();
	}

	handleExit = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		window.app.content_area.current.content_handler('MSM_Transition_Screen', { is_msm_mode: true });
	}

	handleTermsCondition = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('Terms_and_Conditions', { from: "System" });
	}

	handleVersionInformation = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler("Version_Information");
	}

	handleGoogleHome = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler("Google_Home");
	}

	/*handleAlexa = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler("Alexa");
	}*/

	render() {
		const bottom_bar_height = 55;

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			textAlign: 'right',
			color: 'white',
			height: this.props.height - bottom_bar_height,
			overflow: 'auto'
		}

		let button_width = 110;

		let available_functions = this.props.receiver.active_controller.available_functions;
		let username = this.props.receiver.active_controller.username;

		let is_display_sched = available_functions.schedule && username != 'setup' && this.props.receiver.active_controller.user_class == 'Admin'
			&& (this.props.receiver.active_controller.model != 'L01' && this.props.receiver.active_controller.model != 'R01');
		let is_display_interlock = available_functions.interlock && username != 'setup' && this.props.receiver.active_controller.user_class == 'Admin'
			&& (this.props.receiver.active_controller.model != 'L01' && this.props.receiver.active_controller.model != 'R01');
		let is_display_scene = available_functions.scene && username != 'setup'
			&& (this.props.receiver.active_controller.model != 'L01' && this.props.receiver.active_controller.model != 'R01');
		let is_display_change_over = available_functions.change_over && username != 'setup' && this.props.receiver.active_controller.user_class == 'Admin';
		// As long as admin class, able to access User Administration
		let is_display_user_setup = this.props.receiver.active_controller.user_class == 'Admin' ? true : false;
		let is_display_point_settings = this.props.receiver.active_controller.user_class == 'Admin';

		let is_display_iaq = available_functions.iaq_mon && username != 'setup' && this.props.receiver.active_controller.user_class == 'Admin';

		// Standard user cannot access history
		let is_display_history = available_functions.history && username != 'setup' && this.props.receiver.active_controller.user_class == 'Admin';
		let is_display_layout = available_functions.layout && username != 'setup'
			&& this.props.receiver.active_controller.user_class == 'Admin'
			&& !this.props.receiver.is_mobile && this.props.receiver.app_model == 'F';

		let is_display_qr_generator = this.props.receiver.active_controller.user_class == 'Admin';

		// Added is_mobile check to only display Google Home feature when it is mobile version
		// Tommy - 05/08/21 - Only show google home when model is Home and HomeLite
		let is_display_google_home = (this.props.receiver.active_controller.model == 'H01' ||
			this.props.receiver.active_controller.model == 'H02') && this.props.receiver.is_mobile;

		// Tommy - 10/09/21 - Only show alexa when model is Home and HomeLite
		//let is_display_alexa = (this.props.receiver.active_controller.model == 'H01' ||
			//this.props.receiver.active_controller.model == 'H02') && this.props.receiver.is_mobile;

		let is_display_ipcam = false;
		if (available_functions.ipcam != null) {
			// Added is_mobile check to only display IP camera feature when it is mobile version
			if (available_functions.ipcam && this.props.receiver.is_mobile) {
				is_display_ipcam = true;
			}
		}

		let is_display_guest_room = false;
		is_display_guest_room = this.props.receiver.active_controller.user_class == 'Admin' && username != 'setup'
			&& available_functions.unit_manage && this.props.receiver.app_model == 'F';

		// Exit button for MSM sites
		let is_display_exit = this.props.receiver.active_controller.model == 'F10' && !window.app.state.is_msm_mode;

		let is_display_language = true;
		let is_display_password = true;
		let is_display_msm_setting = false;

		if (this.props.receiver.active_controller.model == 'F10' && !window.app.state.is_msm_mode) {
			is_display_language = false;
			is_display_password = false;
			is_display_qr_generator = false;
		} else if (this.props.receiver.active_controller.model == 'F10' && window.app.state.is_msm_mode) {
			is_display_point_settings = false;
		}

		is_display_msm_setting = this.props.receiver.active_controller.model == 'F10' && window.app.state.is_msm_mode
			&& this.props.receiver.active_controller.user_class == 'Admin' && username != 'setup';

		let timestamp_string = '';
		let timestamp = window.app.state.timestamp;
		let locale = getLocale(this.props.receiver.lang);
		timestamp_string = timestamp.toLocaleString(locale, df_options);

		let button_style = {
			cursor: 'pointer',
			verticalAlign: 'top',
			width: button_width,
			height: button_width
		}

		return (
			<div>
				<ConfirmMessage
					is_show={this.state.is_show_confirm}
					message={this.props.receiver.getString('confirm_update')}
					width={this.props.width}
					height={this.props.height}
					receiver={this.props.receiver}
					handleClick={this.onConfirmUpdate}
				/>
				<div style={main_content_style} className='slideInDown'>
					<div style={{ marginTop: 10 }}>
						<div style={{ textAlign: 'left', marginLeft: 20 }}>
							<span style={{ fontSize: 11, color: 'black' }}>{timestamp_string}</span>
						</div>
						<div id='system_buttons' style={{ paddingTop: 20, textAlign: 'center' }}>
							<div id='Schedule' style={{ ...button_style, display: is_display_sched ? 'inline-block' : 'none' }} onClick={this.handleSchedule}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={schedule_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('schedule')}</span>
							</div>
							<div id='Interlock' style={{ ...button_style, display: is_display_interlock ? 'inline-block' : 'none' }} onClick={this.handleInterlock}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={interlock_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('interlock')}</span>
							</div>
							<div id='Scene' style={{ ...button_style, display: is_display_scene ? 'inline-block' : 'none' }} onClick={this.handleSceneSetting}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={scene_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('scene')}</span>
							</div>
							<div id='Changeover' style={{ ...button_style, display: is_display_change_over ? 'inline-block' : 'none' }} onClick={this.handleChangeOver}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={changeover_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('change_over')}</span>
							</div>
							<div id='User_administration' style={{ ...button_style, display: is_display_user_setup ? 'inline-block' : 'none' }} onClick={this.handleUserAdministration}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={user_administration_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('user_administration')}</span>
							</div>
							<div id='Point_Settings' style={{ ...button_style, display: is_display_point_settings ? 'inline-block' : 'none' }} onClick={this.handlePointSettings}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={point_settings_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('point_settings')}</span>
							</div>
							<div id='Guest_Room_Settings' style={{ ...button_style, display: is_display_guest_room ? 'inline-block' : 'none' }} onClick={this.handleGuestRoomSettings}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={guest_room_settings_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('guest_room_settings')}</span>
							</div>
							<div id='MSM_Site_Settings' style={{ ...button_style, display: is_display_msm_setting ? 'inline-block' : 'none' }} onClick={this.handleMSMSettings}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={msm_settings_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('msm_settings')}</span>
							</div>

							<div id='IAQ' style={{ ...button_style, display: is_display_iaq ? 'inline-block' : 'none' }} onClick={this.handleIAQSetting}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={iaq_settings_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('iaq_mon_settings')}</span>
							</div>

							<div id='History' style={{ ...button_style, display: is_display_history ? 'inline-block' : 'none' }} onClick={this.handleHistory}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={history_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('history')}</span>
							</div>

							<div id='Language' style={{ ...button_style, display: is_display_language ? 'inline-block' : 'none' }} onClick={this.handleLanguage}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={lang_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('lang')}</span>
							</div>
							<div id='Password' style={{ ...button_style, display: is_display_password ? 'inline-block' : 'none' }} onClick={this.handlePassword}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={passwd_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('passwd')}</span>
							</div>
							<div id='QR_generator' style={{ ...button_style, display: is_display_qr_generator ? 'inline-block' : 'none', }} onClick={this.handleQRGenerator}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={qr_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('qr_code_gen')}</span>
							</div>
							<div id='Google_Home' style={{ ...button_style, display: is_display_google_home ? 'inline-block' : 'none' }} onClick={this.handleGoogleHome}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={google_home_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('google_home')}</span>
							</div>
							{/* Tommy - 10/09/21 */}
							{/*<div id='Alexa' style={{ ...button_style, display: is_display_alexa ? 'inline-block' : 'none' }} onClick={this.handleAlexa}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={alexa_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('Alexa')}</span>
							</div>*/}
							<div id='IPCam_Settings' style={{ ...button_style, display: is_display_ipcam ? 'inline-block' : 'none' }} onClick={this.handleIPCamSettings}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={ipcam_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('ipcam_settings')}</span>
							</div>
							<div id='Terms_Condition' style={{ ...button_style, verticalAlign: 'top', display: 'inline-block', width: button_width, height: button_width }} onClick={this.handleTermsCondition}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={t_c_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('term_cond')}</span>
							</div>
							<div id='App_Version' style={{ ...button_style, verticalAlign: 'top', display: 'inline-block', width: button_width, height: button_width }} onClick={this.handleVersionInformation}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={version_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('version_information')}</span>
							</div>
							<div id='Check_Update' style={{ ...button_style, verticalAlign: 'top', display: 'inline-block', width: button_width, height: button_width }} onClick={this.handleCheckUpdate}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={check_update_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font }}>{this.props.receiver.getString('check_update')}</span>
							</div>
							<div id='Logout' style={{ ...button_style, display: !is_display_exit ? 'inline-block' : 'none' }} onClick={this.handleLogout}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={logout_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('logout')}</span>
							</div>
							<div id='exit' style={{ ...button_style, display: is_display_exit ? 'inline-block' : 'none' }} onClick={this.handleExit}>
								<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
									<img src={logout_icon} style={{ width: 40 }} />
								</div>
								<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>{this.props.receiver.getString('exit')}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}